var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pdfViewerContainer",staticStyle:{"height":"calc(100vh - 64px)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }